














































































































































































































































































































































































import Vue from 'vue'
import Component from "vue-class-component"
import { Toast, Dialog } from "vant"
import rightsList from './data/rightsList'
import moduleStore from './store/VipWechatPay'
import Cookies from 'js-cookie'
import PayCard from '../../components/pay/pay.vue'
import { throttling, toast } from '@/utils/util'
import { VOICE_RANGE_TYPE } from "@/constants/voice";
import VoiceSelectPopper from "./components/voice-select-popper.vue";
import voiceShop from "../voiceShop/voiceShop"
import VipBanner from "./components/vip-banner.vue"; 
import LZString from '../../utils/lz-string.min'
import { isWeiXin } from "@/utils/open-download-app";
import { customCollectEvent } from '@/utils/collect';

interface IRights {
  icon: string
  name: string
  desc: {
    content: string
    class?: string
  }[]
  isLimitIndex?: number
}

interface IParamsData {
  phone: string
  priceActiveId: number
  jsCode: string
  channelCode: string
}

interface IPriceItem {
  isOnlyVip: any
  id: number
  channelPrice: string
  dailyPrice: string
  duration: string
  price: string
  discount?: string
  subTxt?: string
  nextTxt?: string
  title?: string
  tag?: string
  speakerSelectNum: number
  occurError?: boolean
  vipDays?: number
  priceCountDown?: string
}

interface ISpeakerItem {
  storeId: string
  name: string
  imgUrl: string
  isSelected?: boolean
  packageName?: string
  headerImage?: string
}
interface PaymentInfo {
  wordCountByDay: string,
  wordCount: string,
  price: string,
  allSpeakerNum: string,
  leftDays: string,
  priceByDay: string,
  allWordCount: string
}
interface IAllChannelItem {
  presentSpeakerVOList: ISpeakerItem[]
  vipPackDays: string,
  vipPackageId?: number
}

Component.registerHooks([
  'beforeRouteEnter'
]);
@Component({
  components: {
    PayCard,
    VoiceSelectPopper,
    voiceShop,
    VipBanner
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class vipWechatPay extends Vue {
  avatar = require('/public/images/member/avatar.png');
  king=require('/public/images/member/king.png')
  kingJZ=require('/public/images/member/king_JZ.png')
  bottomTexture=require('/public/images/member/bottom_texture.png')
  checked=require('/public/images/member/checked.png')
  no_checked=require('/public/images/member/no_checked.png')
  support=require('/public/images/member/icon_support.svg')
  not_support=require('/public/images/member/icon_not_support.svg')
  checkedImg=[
    require('/public/images/member/checked0_img.png'),
    require('/public/images/member/checked1_img.png'),
    require('/public/images/member/checked0_img.png'),
    require('/public/images/member/checked0_img.png'),
    require('/public/images/member/checked0_img.png'),
  ];
  // 支付方式 0 微信支付 1 支付宝支付
  payType: number = 0;
  //升级会员的支付方式 0 微信支付 1 支付宝支付
  payType1: number = 0;
  paramsData: IParamsData = {
    phone: '',
    priceActiveId: 6,
    jsCode: '',
    channelCode: ''
  }
  urlChannelCode: string = ''
  urlChannelTarget: string = 'moyin'
  // 发起支付订单参数
  bridgeParams: {
    appId: '',     //公众号ID，由商户传入     
    timeStamp: '',     //时间戳，自1970年以来的秒数     
    nonceStr: '',      //随机串     
    package: '',
    signType: '',     //微信签名方式：     
    paySign: '' //微信签名 
  }
  selectedIndex: number = 0
  // 会员权益列表
  rightsList: IRights[] = rightsList
  // 渠道名称
  channelName: string = ''
  //显示升级的底部弹框
  showUpdateVoice: boolean = false
  // 升级填写手机号
  updatePhone: string = ''
  // 升级手机号填写错误
  isPhoneErrorVisible: boolean = false
  // 魔音套餐列表
  moyinPackageList: []
  // 魔音字数包套餐列表
  moyinWordPackageList: []
  // 元创岛套餐列表
  ycdPackageList: []
  //字数包套餐
  wordPackList: []
  // 价格列表
  priceList: IPriceItem[] = []
  // 当前价格
  payPrice: string = ''
  //升级信息
  paymentInfo: PaymentInfo = {
    "wordCountByDay": "9000",
    "wordCount": "5652000",
    "price": "129368",
    "allSpeakerNum": "517",
    "leftDays": "628",
    "priceByDay": "206",
    "allWordCount": "33000000"
  }
  showPhoneInput: boolean = false
  // 当前折扣
  discount: string = ''
  // 当前的套餐时间
  vipTimeNow: string = '12'
  // 是否携带了渠道参数
  isHasChannerCode: boolean = false
  // 支付订单
  orderId: string = ''
  // 发音人列表
  speakerList: ISpeakerItem[] = []
  // 是否展示声音列表
  isSpeakerListVisible: boolean = false
  // 提示文字是否标红
  isSpeakerSelectedError: boolean = false
  // 是否展示提示文字
  isSpeakerTipsVisible: boolean = true
  // 提示文字
  speakerTipsText: string = '请选择 2 款你喜欢的声音'
  // 设置的套餐映射
  vipPackDaysMap = {}
  // 设置的套餐（）
  vipPackDays: string = ''
  // 元创岛会员权益
  ycdRightsContent = []
  // 定时器对象
  timeout: any = null
  // 避免重复点击
  isBuyBtnDisabled: boolean = false
  //是否显示双11活动
  showActive: boolean = false
  curPriceItem: any = {}
  tabList = []
  selected = 0;
  benefits:any=[];
  bottombtnShow:boolean=false;
  inputHeight:any=0;
  _timer:any=[];
  routerTitle:any='';//跳转去支付成功页面带的title
  activeDot:any=0;
  annualRights=[{
    title:'1年全场声音定制会员',
    bgIcon:require('./images/rights_microphone.png'),
    rights:[{
      icon:require('./images/icon_vip.png'),
      text:'SVIP会员1年'
    },
    {
      icon:require('./images/icon_microphone.png'),
      text:'全场付费声音（220W字/年）'
    },
    {
      icon:require('./images/icon_text.png'),
      text:'AI小魔12W字'
    },
    ]
  },
  {
    title:'1年SVIP会员',
    bgIcon:require('./images/rights_vip.png'),
    rights:[{
      icon:require('./images/icon_vip.png'),
      text:'SVIP会员1年'
    },
    {
      icon:require('./images/icon_text.png'),
      text:'AI小魔16W字'
    },
    {
      icon:require('./images/icon_add.png'),
      text:'加赠：4个指定付费声音*1年'
    },
    {
      icon:require('./images/icon_text_add.png'),
      text:'加赠：全场付费声音27.5W字*1个月'
    }]
  }];
  annualRightsDesc={
    title:'权益叠加使用说明',
    descs:['svip权益：直接叠加，合计24个月','AI小魔：合计28w字，可以在24月内任意时间段使用','全场声音：合计247.5w字，可以在第1-13个月内使用']
  }
  // 当前发音人配置
  get currentSpeakerItem() {
    const id = this.paramsData.priceActiveId;
    let item = this.vipPackDaysMap[id];
    return item;
  }
  // 根据选择的套餐类型限制最多选择发音人个数
  get currentSpeakerSelectNum() {
    return this.currentSpeakerItem?.speakerSelectNum ?? 0;
  }
  get currentSpeakerList() {
    return this.currentSpeakerItem?.presentSpeakerVOList ?? [];
  }
  // 套餐滚动获取高亮显示的点
  scrollPrice(){
    let scrollLeft=(this.$refs.srcollpriceA as any).scrollLeft;
    this.activeDot=Math.ceil(scrollLeft/400)
  }
  clearTime(clearIndex = null){
    if (this._timer) {
      this._timer.forEach((element, elementIndex) => {
        if (elementIndex === clearIndex || clearIndex === null) {
          element && clearInterval(element)
          this.$set(this._timer, elementIndex, null)
        }
      });
    }
  }
  changeActive(res){
    this.clearTime()
    this.selected = res
    switch(this.selected) {
      case 0:
        this.priceList = this.moyinPackageList
        break;
      case 1:
        this.priceList = this.moyinPackageList
        break;
      case 3:
        this.priceList = this.ycdPackageList
        break
      case 4:
        this.priceList = this.wordPackList
        break
    }
    // 创建定时器存储数组
    this._timer = new Array(this.priceList.length).fill(null)
    this.priceList = this.priceList.map((item, index) => {
      // 渠道价格
      const channelPrice = (Number(item.channelPrice) / 100).toFixed(2).replace(/\.00/, '')
      // 原价价格
      const price = (Number(item.price) / 100).toFixed(2).replace(/\.00/, '')
      // 日均价格
      const dailyPrice = (Number(item.channelPrice) / (100 * item.vipDays)).toFixed(2)

      // 计算已选择的价格
      if (index === 0) {

        if(this.channelName && this.channelName !== '官方分销'){//渠道默认选择第一个
          this.payPrice = channelPrice// 设置当前价格
          this.paramsData.priceActiveId = item.id//  当前id
          this.curPriceItem = item
        }

        // 设置当前折扣
        this.discount = item.discount
        // 设置当前套餐
        this.vipTimeNow = item.duration
      }
      
      //倒计时时间
      //console.log(item.priceCountDown)
      if(item.priceCountDown!=null){
        this.getEndTime(v1=>{
          this.priceList[index]['leftTime']=v1;
          this.$set(this.priceList,index,this.priceList[index])
        },item.priceCountDown, index)
      }
      return {
        ...item,
        channelPrice,
        dailyPrice,
        price
      }
    })
    console.log(this.priceList);
    if(this.selected === 0 || this.selected === 1){
      let pricelist = this.priceList.filter(item => item.isOnlyVip === !this.selected)
      this.paramsData.priceActiveId = pricelist[0].id
      this.payPrice = pricelist[0].channelPrice
      this.curPriceItem = pricelist[0]
      //会员展示曝光添加埋点-todo
        customCollectEvent('vip_pay_exposure', {
          button:'h5短信购买',
          user_id:''//短信支付进入没有wwid
        });
    } else if (this.selected === 3) {
      // 元创岛套餐
      this.paramsData.priceActiveId = this.priceList[0].id
      this.payPrice = this.priceList[0].channelPrice
      this.curPriceItem = this.priceList[0]
    }
  }

  // 元创岛会员套餐（在这里获取会员的权益）
  ycdVipPackageList = []

  // 单位 map
  unitMap = {
    'day': '天',
    'month': '个月',
    'year': '年'
  }

  get activeYcdVipPackage () {
    let packageItem = {}
    this.ycdVipPackageList.forEach((item) => {
      if (item.packageId === this.curPriceItem.id) {
        packageItem = item
      }
    })
    return this.selected === 3
      ? packageItem
      : {}
  }

  /** 获取元创岛套餐列表 */
  getYcdVipPackageList() {
    const params = {
      type: 1,
      isShow: false
    }
    this.$http('getYcdPackageListApi', params)
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          this.ycdVipPackageList = data
        }
      })
  }

  // 获取元创岛会员权益
  getYcdMemberRightList() {
    this.$http('getYcdVipRightsListApi')
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          this.ycdRightsContent = data
        }
      })
  }
  // 是否展示权益
  isRightsItemShow(rightsItem) {
    return (
      (!rightsItem.isLimitIndex ||
        parseInt(this.vipTimeNow) >= 12 ||
        !this.curPriceItem.isOnlyVip) &&
      (rightsItem.name !== "超优惠" ||
        !["10", null, ""].includes(this.curPriceItem.discount))
    );
  }
  // 权益数量
  get rightsNum() {
    let num = 0;
    this.rightsList.forEach((rightsItem) => {
      if (this.isRightsItemShow(rightsItem)) {
        num++;
      }
    });
    return num;
  }
  transformSpeaker(speakerItem) {
    return {
      storeId: speakerItem.storeId,
      speakerId: speakerItem.speakerId,
      name: speakerItem.packageName || speakerItem.name,
      imgUrl: speakerItem.headerImage,
      isSelected: false,
    };
  }
  //获取字数包sku
  getCurWordPack() {
    // const channelCode = Cookies.get('CHANNEL_CODE') || ''
    let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
    this.$http('getWordPack', { businessType: 'aiDoc', channelCode }).then((res: any) => {
      if (res.code == '200') {
        let resData = res.data
        console.log('getWordPack', resData);

        if (resData.length > 0) {
          if (this.channelName && this.channelName !== '官方分销') {

            this.tabList = [...this.tabList, {
              code: 4,
              title: '字数包',
            }]
          } else {
            this.tabList = [...this.tabList, {
              code: 4,
              title: '字数包',
              subtitle: 'AI文案生成'
            }]

          }

        }
        this.wordPackList = resData
        console.log('this.wordPackList', this.wordPackList);
        
      }
    })
  }
  handleScroll(){
    this.$nextTick(()=>{
      let rightBox=document.querySelector('.rights-box')
      let boxTop=rightBox.getBoundingClientRect().top;
      this.bottombtnShow=boxTop<10?true:false;
    })
  }
  destroyed(){
    
    this.clearTime()
  }
  async mounted() {
    window.addEventListener('scroll',this.handleScroll,true)
    this.clearTime()
    if(isWeiXin()){//微信环境先调用授权
    console.log('微信环境')
    if (this.getAuth()) { //测试注释
      // 获取渠道名称
      this.getChannelCodeName({
        success: async () => {
          await Promise.all([
            // 获取价格列表
            this.getPriceList(),
            // 获取发音人列表
            this.getSpeakerList(),
          ]);
          // 等待价格和旧发音人接口完成后，查询新发音人接口
          await this.getAllFirstPageSpeakerListNew();
        }
      })
    }
    }else{//非微信环境直接调用接口
      // 获取渠道名称
      this.getChannelCodeName({
        success: async () => {
          await Promise.all([
            // 获取价格列表
            this.getPriceList(),
            // 获取发音人列表
            this.getSpeakerList(),
          ]);
          // 等待价格和旧发音人接口完成后，查询新发音人接口
          await this.getAllFirstPageSpeakerListNew();
        }
      })
    }
    this.getUpgradableState()
    this.getVipCenters();
    this.getYcdMemberRightList()
    this.getYcdVipPackageList()
    // 初始化
    this.focusCallback()
  }
  getVipCenters(){
    this.$http('getVipCenter',{}).then(res=>{
        this.benefits=res.data;
        this.benefits.forEach(re1=>{
        re1.detailList.forEach(re2=>{
          re2.showDes=false;
        })
      })
    })
  }
  //点击显示描述
  isShowdes(it){
    this.benefits.forEach(re1=>{
      re1.detailList.forEach(re2=>{
        if(it.description==re2.description){
          re2.showDes=!re2.showDes;
        }else{
          re2.showDes=false;
        }
      })
    })
    this.$set(this.benefits,0,this.benefits[0])
  }
  isClosedes(){
    this.benefits.forEach(re1=>{
      re1.detailList.forEach(re2=>{
          re2.showDes=false;
      })
    })
    this.$set(this.benefits,0,this.benefits[0])
  }
  /**
   * 路由前置守卫
   */
  created() {
    // 清除原本的 cookies
    if (Cookies.get('USER_CODE')) Cookies.remove('USER_CODE')
    if (Cookies.get('CHANNEL_CODE')) Cookies.remove('CHANNEL_CODE')
    const href = window.location.href
    if (href.indexOf('/?code') !== -1) {
      const urlArr = href.split('/?')
      const rightUrlArr = urlArr[1].split('#/')
      const queryObj = {}
      // 获取code和state参数
      rightUrlArr[0]
        .split('&')
        .map((item) => {
          const splitStr = item.split('=')
          return {
            key: splitStr[0],
            value: splitStr[1],
          }
        })
        .forEach((item) => {
          queryObj[item.key] = item.value
        })
      if (queryObj['code']) {
        console.log("sessionStorage", queryObj['code']);

        sessionStorage.setItem('USER_CODE', queryObj['code'])
        Cookies.set('USER_CODE', queryObj['code'] as string, { expires: 270 / 24 / 60 / 60 })

      }
      if (queryObj['state']) {
        if (queryObj['state'].includes('|||')) {
          const [code, target] = queryObj["state"].split("|||");
          Cookies.set("CHANNEL_CODE", code as string, { expires: 1 });
          Cookies.set("CHANNEL_TARGET", target as string, { expires: 1 });
        } else {
          Cookies.set('CHANNEL_CODE', queryObj['state'] as string, { expires: 1 })
        }
      }
    }
    if (href.indexOf('channelCode=') !== -1) {
      console.log(href)
      let paramsArr = href.split('channelCode=')
      let supStr = paramsArr[1].split('&')[0]
      if (supStr.indexOf('ww_token') !== -1) {
        Cookies.set('CHANNEL_CODE', supStr.split("ww_token")[0], { expires: 1 })
      } else {
        Cookies.set('CHANNEL_CODE', supStr, { expires: 1 })
      }
      this.urlChannelCode = supStr;
    }
    if (href.indexOf('target=') !== -1) {
      let paramsArr = href.split('target=')
      let supStr = paramsArr[1].split('&')[0]
      if (supStr.indexOf('ww_token') !== -1) {
        Cookies.set('CHANNEL_TARGET', supStr.split("ww_token")[0], { expires: 1 })
      } else {
        Cookies.set('CHANNEL_TARGET', supStr, { expires: 1 })
      }
      this.urlChannelTarget = supStr;
    }
  }
  focusCallback() {
    const input = document.querySelector('#input');
    const payCard = document.querySelector('#payCard');
    if(!input) return
    const ua = navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua);
    console.log('focus ---- pay');
    
    input.addEventListener('focus', () => {
      console.log(input, 'input ---- dom');
      
      setTimeout(() => {
        if (iOS) {
          if (!/OS 11_[0-3]D/.test(ua)) {
            document.body.scrollTop = document.body.scrollHeight;   
          }
        } else {
          payCard.scrollIntoView(true);
          // (document.body as any).scrollTop(80)
        }
      }, 300);
    })
	}
  getUrlCode() {
    // 在 url 后面拼上 jscode ，用于本地和测试环境测试
    const urlJSCode = this.$route.query.custom_jscode
    if (urlJSCode) return urlJSCode
    
    let href = window.location.href
    	// href = 'http://10.30.100.89:8065/#/voiceAll/?code=011gOEll2E1vi94U0qml2B0iPU0gOElm'
    if (Cookies.get('USER_CODE')) {
      return Cookies.get('USER_CODE')
    }
    if (href.indexOf('code=') !== -1) {
      const urlArr = href.split('?')
      const rightUrlArr = urlArr[1].split('#/')
      const queryObj = {}
      // 获取code和state参数
      rightUrlArr[0]
        .split('&')
        .map((item) => {
          const splitStr = item.split('=')
          return {
            key: splitStr[0],
            value: splitStr[1],
          }
        })
        .forEach((item) => {
          queryObj[item.key] = item.value
        })
      if (queryObj['code']) {
        return queryObj['code']
      }
    }
    if (sessionStorage.getItem("USER_CODE")) {
      return sessionStorage.getItem("USER_CODE")
    }
    return null
  }
  getUpgradableState() {
    // const channelCode = Cookies.get('CHANNEL_CODE') || '';
     let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
    this.$http('getUpgradableStatus', {
      channelCode
    }).then((res) => {
      this.showActive = res.data
    })
  }

  /**
   * 调用授权
   */
  getAuth() {
    let jsCode = this.getUrlCode()
    console.log('jscode----',jsCode );
    if (!jsCode) {
      // 获取 channelCode
      let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
      // 获取 target
      const channelTarget = Cookies.get('CHANNEL_TARGET') || ''
      // 域名 url
    //   const myURL = process.env.NODE_ENV === 'production'
    //     ? 'https://voice-maker-mobile.mobvoi.com/#/vipWechatPay'
    //     : 'https://m-pre.moyin.com/#/vipWechatPay'
     
      let myURL = location.href
    //   if(location.href.indexOf("m.moyin.com")){
    //     //公众号支付只能配置两个域名，且6月修改次数已用完，临时代码替换
    //     myURL=location.href.replace('m.moyin.com','tc-nj-m.moyin.com')
    //   }
      // 调用授权登录接口
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxea4ae255733cb575&redirect_uri=${encodeURIComponent(myURL)
        }&response_type=code&scope=snsapi_base&state=${encodeURIComponent(`${channelCode}${channelTarget ? "|||" + channelTarget : ""}`)
        }#wechat_redirect`

      return false
    } else {
      this.paramsData.jsCode = jsCode||''
      return true
    }
  }
  updateVoice() {
    this.showPhoneInput = true
    this.updatePhone = ''
  }
  toserveDetail() {
    this.$router.push('/protocol')
  }
  /**
   * 获取渠道名称
   */
  getChannelCodeName(callback) {
    const { success } = callback
    // 获取 channelCode
     let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
    this.$http('getChannelName', {
      channelCode
    })
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          this.channelName = data;//两种 传了channelCode就查数据库，查到就返回对应的渠道名称，没查到就固定返回“官方渠道” 没传就返回channelCode为office_mobvoi对应的渠道名称
         console.log('channelName',this.channelName);
         
          if(this.channelName && this.channelName !== '官方分销'){
            this.tabList = [
          
              {
                code: 0,
                title: '魔音会员'
              }, {
                code: 2,
                title: '声音'
              }, {
                code: 3,
                title: '元创岛会员'
              },
              ...this.tabList,
            ]
          } else {
            this.tabList = [
   
              {
                code: 0,
                title: '魔音会员',
                subtitle: '会员声音免费用'
              }, {
                code: 1,
                title: '全场声音会员',
                subtitle: '全场声音免费用'
              }, {
                code: 2,
                title: '声音',
                subtitle: '海量优选声音'
              }, {
                code: 3,
                title: '元创岛会员',
                subtitle: '一键成片'
              },
              ...this.tabList
            ]
          }
          success()
          this.getCurWordPack()
        }
      })
      .catch(error => {
        console.error(error)
      })
  }
  /**
   * 获取价格列表
   */
  getPriceList() {
    // 获取 channelCode
let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
    return this.$http('getVipPriceList', {
      channelCode,
      ww_token: '',
      sourceEnum: 'MINI_PROGRAM'
    })
      .then(res => {
        const { code, data, msg } = res
        if (code === 200) {
          this.moyinPackageList = data.superPack || []
          this.ycdPackageList = data.bhVipPack || []
          console.log(this.moyinPackageList, this.ycdPackageList)
          // 只有元创岛套餐时 title 改为 元创岛
          if (!this.moyinPackageList.length && this.ycdPackageList.length) {
            document.title = '元创岛'
          }
          // 修改上方 tab 展示内容
          this.tabList = this.tabList.filter(item => {
            if (!this.moyinPackageList.length && this.ycdPackageList.length) {
              return !(item.code === 0 || item.code === 1 || item.code === 2)
            }
            if (!this.ycdPackageList.length && item.code === 3) {
              return false
            }
            return true
          })
          // 当前的套餐列表
          let priceList = this.selected === 3 ? data.bhVipPack : data.superPack

          if(this.channelName && this.channelName == '官方分销'){
            let handlePricelist = priceList.filter(item=> item && item.isOnlyVip === !this.selected)
            this.paramsData.priceActiveId=handlePricelist[0].id
            this.payPrice = (handlePricelist[0].channelPrice / 100).toFixed(2).replace(/\.00/, '')
            this.curPriceItem = handlePricelist[0]
          }

          if (this.urlChannelTarget === 'ycd') {
            if (this.ycdPackageList.length) {
              this.changeActive(3)
            } else {
              this.changeActive(0)
            }
          } else {
            if (!this.moyinPackageList.length) {
              this.changeActive(3)
            } else {
              this.changeActive(0)
            }
          }
        } else {
          console.error(msg)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  getEndTime(fn, e, index){
    let time=  (e.split(":")[0])*3600000+(e.split(":")[1])*60000+(e.split(":")[2])*1000;
    const endTime1 = new Date(Date.now() + time).getTime();
    this.$set(this._timer, index, setInterval(()=>{
      let leftTime= this.updateCountdown(endTime1, index);
      fn&&fn(leftTime)
    },1000))
  }

  updateCountdown(endTimes, index) {
    const now = new Date().getTime();
    const remainingTime = endTimes - now;
    if (remainingTime <= 0) {
      // 倒计时结束
      this.clearTime(index)
      this.getPriceList()
      return;
    } 

    const h = Math.floor(remainingTime / 1000 / 60 / 60 % 24)<10?('0'+Math.floor(remainingTime / 1000 / 60 / 60 % 24)):Math.floor(remainingTime / 1000 / 60 / 60 % 24),
        m = Math.floor(remainingTime / 1000 / 60 % 60)<10?('0'+Math.floor(remainingTime / 1000 / 60 % 60)):Math.floor(remainingTime / 1000 / 60 % 60),
        s = Math.floor(remainingTime / 1000 % 60)<10?('0'+Math.floor(remainingTime / 1000 % 60)):Math.floor(remainingTime / 1000 % 60);
    const result=h + ":" + m + ":" + s;
    return result;
  }


  /**
   * 获取发音人列表
   */
  getSpeakerList() {
    // 获取 channelCode
    // const channelCode = Cookies.get('CHANNEL_CODE') || ''
    let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
    console.log('getSpeakerList', channelCode);
    
    // 渠道为空则不请求接口
    if (!channelCode) {
      return
    }
    return this.$http('getSpeakerListApi', {
      'channel_code': channelCode
    })
      .then(res => {
        console.log(res, 'list')
        const { code, data, msg } = res
        if (code === 200) {
          let vipPackDaysMap={}
          data.forEach((item) => {
            if (item.presentSpeakerVOList) {
              item.presentSpeakerVOList = item.presentSpeakerVOList.map(
                this.transformSpeaker
              );
            }
            vipPackDaysMap[item.vipPackageId] = item;
          });
          this.vipPackDaysMap=vipPackDaysMap
        } else {
          console.error(msg)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  /**
   * 新版获取发音人信息接口
   */
  getSpeakerListNew({ priceId, currentPage = 0, keyword = "" }) {
    const pageSize = 100;
    return this.$http("getSpeakerListApiNew", {
      vipPackageId: priceId,
      keyWord: keyword,
      pageNum: currentPage + 1,
      pageSize,
    }).then((res) => {
      const { code, data } = res;
      if (code !== 200) {
        // 查询出错
        console.log("查询出错:", res);
        return Promise.reject(res);
      }
      if (data) {
        const pageData = data.selectedSpeakerVOList.map(this.transformSpeaker);
        if (currentPage === 0) {
          this.vipPackDaysMap = {
            ...this.vipPackDaysMap,
            [priceId]: {
              ...data,
              presentSpeakerVOList: pageData,
              supportSearch: true, // 新接口支持搜索
              currentPage: 0,
              pageSize,
              noMore: false,
            },
          };
        } else {
          this.vipPackDaysMap[priceId].presentSpeakerVOList =
            this.vipPackDaysMap[priceId].presentSpeakerVOList.concat(pageData);
        }
        const currentSpeakerItem = this.vipPackDaysMap[priceId];
        currentSpeakerItem.currentPage = currentPage;
        currentSpeakerItem.noMore =
          currentSpeakerItem.presentSpeakerVOList.length >=
          currentSpeakerItem.totalCount;
      } else {
        console.log(`"${priceId}"没有发音人列表`);
      }
    });
  }
  // 获取全部新版发音人第一页接口
  getAllFirstPageSpeakerListNew() {
    // 旧发音人接口没有查到发音人数据 并且需要选择发音人的 走新接口
    const priceList = this.priceList.filter(
      (priceItem) =>
        priceItem.speakerSelectNum > 0 && !this.vipPackDaysMap[priceItem.id]
    );
    return Promise.all(
      priceList.map((priceItem) => {
        const priceId = priceItem.id;
        return this.getSpeakerListNew({
          priceId,
        }).catch(() => {
          this.priceList.find((item) => {
            if (item.id === priceId) {
              item.occurError = true;
            }
          });
        });
      })
    );
  }
  // 获取当前套餐发音人列表
  getCurrentSpeakerListNew({ keyword, currentPage }) {
    const priceItem = this.curPriceItem;
    const speakerItem = this.currentSpeakerItem;
    if (currentPage === 0) {
      // 重新查询第0页
      speakerItem.noMore = false;
    }
    if (typeof currentPage !== "number") {
      // 查询下一页
      currentPage = speakerItem.currentPage + 1;
    }
    if (!speakerItem.supportSearch || speakerItem.noMore) {
      // 没有更多了
      return;
    }
    return this.getSpeakerListNew({
      priceId: priceItem.id,
      currentPage,
      keyword,
    });
  }
  // 获取发音人声音范围
  getSpeakerRangeHTML() {
    const { rangeType, isOnlyVip } = this.curPriceItem;
    if (rangeType === VOICE_RANGE_TYPE.ANYONE) {
      return "（选择任意一款声音）";
    } else if (rangeType === VOICE_RANGE_TYPE.SOMEONE) {
      return "（指定一款可用声音）";
    } else if (rangeType === VOICE_RANGE_TYPE.ANYONE_PAID) {
      return "（选择任意一款付费声音）";
    } else if (rangeType === VOICE_RANGE_TYPE.ALL_CHN) {
      return "（免费使用「全场中文发音人」）";
    } else if (rangeType === VOICE_RANGE_TYPE.ALL_VIP) {
      return "（免费使用「超级会员专属声音」）";
    } else if (rangeType === VOICE_RANGE_TYPE.ALL) {
      return '（免费使用「<b class="orange">全场声音</b>，含付费声音」）';
    } else if (isOnlyVip) {
      return "（免费使用「超级会员专属声音」）";
    } else {
      return '（免费使用「<b class="orange">全场声音</b>，含付费声音」）';
    }
  }
 
  /**
   * 选择价格套餐
   */
  choosePrice(priceItem: IPriceItem, key: number) {
    console.log("选择价格套餐1", priceItem,this.selected);
    // 设置当前套餐 active
    this.selectedIndex = key
    this.curPriceItem = priceItem
    this.paramsData.priceActiveId = priceItem.id
    /* this.priceList.forEach(item => {
      if (item.id === priceItem.id) { */
    this.payPrice = priceItem.channelPrice
    // 设置当前折扣
    this.discount = priceItem.discount
    // 设置当前套餐
    this.vipTimeNow = priceItem.duration
    /*   }
    }) */
    // 设置当前的声音包列表
 
  }
  /**
   * 验证手机号
   */
  checkPhone(phone) {
    let myreg = /^[1][0-9]{10}$/;
    let res = myreg.test(phone)
    if (!res) {
      this.isPhoneErrorVisible = true
    }
    return res
  }
  phoneFocus(e) {
    this.isPhoneErrorVisible = false
    if (e.detail.height) {
      this.inputHeight = e.detail.height //这个高度就是软键盘的高度
    }
  }

  /**
   * 确认选择的发音人声音包
   */
  confirmSpeaker(selectSpeakerList) {
    this.buySuperVip(selectSpeakerList);
  }
  
  /**
   * 设置套餐权益的会员购买
   */
  getpaymentInfo() {
    if (!this.checkPhone(this.updatePhone)) {
      return
    }
    let params = {
      phone: this.updatePhone,
      isUpgrade: true
    }
    Dialog.confirm({
      title: `请确认手机号:${this.updatePhone}`,
      message: '支付后不支持更换手机号、退款，请确认后再支付',
      confirmButtonText: '确认支付',
      cancelButtonText: '修改手机号',
      className: 'rel-dialog',
    }).then(() => {
      //   // on confirm
      //   // 调用购买方法
      return this.$http("showPaymentInfo", {
        ...params
      })
    }).then((res) => {
      if (res.code == 200) {
        this.paymentInfo = res.data
        this.paramsData.phone = this.updatePhone
        this.showUpdateVoice = true
      } else {
        Toast({
          message: res.message,
          icon: "none",
          duration: 3000,
          position: 'top'
        })
      }

    }).catch((err) => {
      if (err.message) {
        Toast({
          message: err.message,
          icon: "none",
          duration: 1000,
          position: 'top'
        })
      }

    })

  }
  onPayConfirm() {
    this.routerTitle=this.curPriceItem.title;
    const { phone } = this.paramsData;
    const jsCode = this.getUrlCode();  
    console.log('---获取jscode',jsCode)
    if (this.curPriceItem.occurError) {
      toast("出错了，请重新打开页面进行购买～", "top");
      return;
    }
    if (!(this.$refs.payCard as any).phoneCheck()) {
      return
    }
     else if (isWeiXin()&& !jsCode) {
      // 重新授权
      this.getAuth();//本地测试注释，非微信浏览器可打开
      return;
    }
    
    Dialog.confirm({
      title: `请确认手机号:${phone}`,
      message: "支付后不支持更换手机号、退款，请确认后再购买",
      confirmButtonText: "确认购买",
      cancelButtonText: "修改手机号",
      className: "rel-dialog",
    })
      .then(() => {
        console.log('---heihei')
        // 关闭手机号验证警告
        this.isPhoneErrorVisible = false;
        if (this.currentSpeakerItem && this.currentSpeakerList.length > 0) {
          // 显示声音选择弹出层
          this.isSpeakerListVisible = true;
        } else {
          this.buySuperVip();
        }
        // 捕获用户错误（讲真用户凌晨购买套餐时未弹出弹窗）
        customCollectEvent('catch_user_error', {
          speakerItem: this.currentSpeakerItem ? JSON.stringify(this.currentSpeakerItem) : 'null',
          priceActiveId: this.paramsData?.priceActiveId || '',
          vipPackDaysMap: this.vipPackDaysMap ? JSON.stringify(this.vipPackDaysMap) : 'null'
        });
      })
      .catch(() => {
        // on cancel
        let focusNode: any = this.$refs.payCard;
        focusNode.focus();
      });
  }
  buySpecialSuperVip() {
    this.payConfirm().then(() => {
      this.isSpeakerListVisible = true
    })
  }
  // 普通购买会员支付
  buyNormalConfirm(){
    this.payConfirm().then(() => {
      this.buyNormalSuperVip()
    })
  }
  // 付款前确认手机号，校验jscode
  payConfirm() {
    return new Promise((resolve, reject) => {
      const { phone } = this.paramsData
      const jsCode = this.getUrlCode()
      console.log('special jscode', jsCode)
      if (!(this.$refs.payCard as any).phoneCheck()) {
        reject()
        return
      }else if (isWeiXin()&&!jsCode) {
        // 重新授权
        this.getAuth()//测试注释
        reject()
        return
      }
      Dialog.confirm({
        title: `请确认手机号:${phone}`,
        message: '支付后不支持更换手机号、退款，请确认后再购买',
        confirmButtonText: '确认购买',
        cancelButtonText: '修改手机号',
        className: 'rel-dialog',
      }).then(() => {
        //   // on confirm
        // 关闭手机号验证警告
        resolve('ok')
        // this.buyNormalSuperVip()
      }).catch(() => {
        // on cancel
        let focusNode: any = this.$refs.payCard
        focusNode.focus()
        reject()
      })
    })
  }
  // 升级支付
  updatePackage() {
    const jsCode = this.getUrlCode()
    if(!jsCode&&isWeiXin()) {
      this.getAuth()//测试注释
      return
    }
    this.showUpdateVoice = true
    this.buyNormalSuperVip()
  }
  /**
   * 未设置套餐权益
   */
  buyNormalSuperVip = throttling(() => {
    this.buySuperVip()
  }, 500)
  // 购买成功页面路径
  get successRoute() {
    console.log(".....",this.curPriceItem.title)
    return this.selected === 3
      ? {
          path: "/ycdPaySuccess",
          query: {
            phone: this.paramsData.phone,
            title: this.routerTitle,
            rightsNum: this.rightsNum + ""
          }
        }
      : {
          path: "/paySuccess",
          query: {
            phone: this.paramsData.phone,
            title: this.routerTitle,
            rightsNum: this.rightsNum + ""
          }
        }
  }
  /**
   * 调起下单接口
   */
  buySuperVip(list?) {
     console.log("选择价格套餐2",this.curPriceItem,this.payType);
    // 解构赋值
    const { phone, priceActiveId: packageId } = this.paramsData
    // 从本地缓存获取渠道 code
    // const channelCode = Cookies.get('CHANNEL_CODE') || '';
    let  channelCode = Cookies.get('CHANNEL_CODE') || '';
      if(channelCode.includes('|||')){
        channelCode = '';
      }
    // 初始化手机提示状态
    this.isPhoneErrorVisible = false
    // 设置接口参数
    let params: any = {}
    let payComponent: any = this.$refs.payCard
    // 创建订单参数，魔音是 0 ，元创岛是 1
    const sourceType = this.selected === 3 ? 1 : 0
    // 
    const selectSpeakerList = list || []
    // 判断是否符合设置的套餐
    if (this.vipPackDaysMap[this.paramsData.priceActiveId] && selectSpeakerList.length) {
      if (selectSpeakerList && selectSpeakerList.length) {
        const storeIdList = [], speakerIdList = [];
        selectSpeakerList.forEach((item) => {
          if (item.storeId) {
            storeIdList.push(item.storeId);
          } else {
            speakerIdList.push(item.speakerId);
          }
        });
        params = {
          phone,
          packageId,
          jsCode: this.paramsData.jsCode||'',
          channelCode,
          speakerStoreIDArray: storeIdList,
          speakerIdArray: speakerIdList,
          payType: this.payType,
          sourceType
        }
      } else {
        Toast({
          message: "您有 2 款免费发音人权限",
          icon: "none",
          duration: 1000,
          position: 'top'
        })
        // 关闭禁用
        this.isBuyBtnDisabled = false
        return
      }
    } else {
      params = {
        phone,
        packageId,
        jsCode: this.paramsData.jsCode||'',
        channelCode,
        speakerStoreIDArray: '',
        payType: this.payType,
        sourceType,
        speakerIdArray: ''
      }
    }
    let httpUrl = "paySuperVip"
    if (this.showUpdateVoice) {
      // httpUrl
      httpUrl = "h5UpgradeOrder"
      params.isUpgrade = true
      params.payType = this.payType1
      payComponent = this.$refs.updatePayCard
    }
    if(this.selected==4){
      httpUrl = "createWordH5Order"
      params={
        ...params,
        type:'aiDoc',
        count:1,
        packId:params.packageId
      }
      
    }
    console.log('---准备调用后端下单接口')
    // 调用后端的下单接口
    this.$http(httpUrl, {
      ...params
    })
      .then(res => {
        console.log('---调用了后端下单接口',res)
        // 关闭提示框
        this.isSpeakerListVisible = false
        // 关闭禁用
        this.isBuyBtnDisabled = false

        const { code, data } = res
        console.log('----调用后端下单之后',res,this.showUpdateVoice,this.payType1,code);
        if (code === 200) {
            console.log('是否是微信环境',isWeiXin())
            //微信环境走原先的旧逻辑-公众号JSAPI支付,参数jscode必须有值
            if(isWeiXin()){
                if(this.showUpdateVoice && this.payType1 === 1 ||
                    (!this.showUpdateVoice && this.payType === 1)
                ){
                    console.log('微信环境,阿里支付',data);
                    //阿里支付
                    payComponent.aliPay({...data, from: 'vipWechatPay', isVoice: this.showUpdateVoice?'1':''}, this.successRoute)
                    return
                }
                const { appId, timeStamp, nonceStr, signType, paySign, package: prepayId, orderId } = data
                console.log('--zhunbei',prepayId)
                // 设置支付下单参数
                this.bridgeParams = {
                    appId,
                    timeStamp,
                    nonceStr,
                    signType,
                    paySign,
                    package: prepayId
                }
                console.log('--bridgeParams',this.bridgeParams)
                this.orderId = orderId
                console.log('--orderId',this.orderId)
                // 调用微信的发起支付接口
                payComponent.wxPay(this.bridgeParams).then(res => {
                    console.log('---调用微信的发起支付接口')
                    //会员支付成功埋点
                    try{
                      customCollectEvent("vip_pay_success", {
                        amount: this.curPriceItem.channelPrice,
                        button: `魔音 ${this.tabList[this.selected]?.title || ""}${
                          this.tabList[this.selected]?.subtitle || ""
                        } ${this.curPriceItem.title}`,
                        channel_code: channelCode || "",
                        user_id: "",
                      }); 
                    }catch(e){
                    console.log('购买会员成功埋点失败',e)
                    }
                    // 跳转到成功页
                    if (this.showUpdateVoice) {
                    Toast({
                        message: '升级为全场声音包成功',
                        icon: "none",
                        duration: 4000,
                        position: 'top'
                    })
                    this.showUpdateVoice = false
                    } else if(this.selected==4){
                    Toast({
                        message: `${this.curPriceItem.title}套餐购买成功`,
                        icon: "none",
                        duration: 4000,
                        position: 'top'
                    })
                    } else{
                    this.$router.push(this.successRoute)
                    }

                })
            }else{
                console.log('---走h5支付')
                let payParams = res.data;
                //非微信环境走h5支付
                this.h5Pay({ ...payParams });
            }
            

        
        } else {
          let errMsg = res.message==="未获取到openId"?"请在微信客户端打开链接":res.message;
          Toast({
            message: errMsg,
            icon: "none",
            duration: 3000,
            position: 'top'
          })
        }
      })
      .catch(error => {
        // 关闭提示框
        this.isSpeakerListVisible = false
        // 关闭禁用
        this.isBuyBtnDisabled = false
        toast("出错了，请重新打开页面进行购买～", "top");
        console.error(error)
      })
  }
  /**
   * 修改手机号
   */
  phoneChange(val) {
    this.paramsData.phone = val
  }
  /**
   * 购买会员改变支付方式
   * @param v 
   */
  changPayMethod(v) {
    this.payType = v
  }
  /**
   * 升级会员改变支付方式
   * @param v 
   */
  changPayMethod1(v) {
    this.payType1 = v
  }
  toProtocol(name) {
    if (this.selected === 3) {
      this.toYCDProtocol(name)
      return
    }
    this.$router.push({
      path: "/"+name,
    });
  }
  //h5支付
  h5Pay(payInfo: any, succObj?: any) {
    let infoCompress = LZString.compressToBase64(JSON.stringify({
        ...payInfo,
    }))
    
    let payType ='';
    if (this.showUpdateVoice) {//是升级
      payType = this.payType1===1?'alipayH5':'wxpayH5';
    }else{
      payType = this.payType===1?'alipayH5':'wxpayH5';
    }
    console.log('---infoCompress',infoCompress,payType)
    this.$router.push({
      path: '/middlePageOfPay',
      query: {
        info: infoCompress,
        // from: 'sameType',
        payType:payType,
        phone: this.paramsData.phone,
        desc:''
      },
    });
  }

  toYCDProtocol(name: string) {
    switch(name) {
      case 'protocol':
        window.open('https://h5.yuan365.com/#/protocol')
        break;
      case 'privacy':
        window.open('https://h5.yuan365.com/#/privacy')
        break;
    }
  }

}

